export default __webpack_public_path__ + "static/media/491.8c8cffba.gif";